// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { Component } from './component';

/**
 * @class Jsw.Gauge
 * @extends Jsw.Component
 *
 * Example usage:
 *
 *     @example
 *     new Jsw.Gauge({
 *         renderTo: document.body,
 *         value: 75
 *     });
 */
export const Gauge = Class.create(Component, {
    _tag: 'div',

    /**
     * @cfg {Number} value
     */

    _initConfiguration($super, config) {
        $super(config);
        this._cls = this._getConfigParam('cls', 'progress progress-sm');
    },

    _initComponentElement($super) {
        $super();

        this.setProgress(this._getConfigParam('value', ''));
    },

    setProgress(value) {
        this._componentElement.update(
            `<div class="progress-bar" style="width: ${value}%"></div>`
        );
    },
});



// WEBPACK FOOTER //
// ./jsw/gauge.js